// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'babel-polyfill'
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);
import './assets/css/index.css';
import 'amfe-flexible/index.js'
import './assets/css/quill.snow.css'
Vue.config.productionTip = false
router.beforeEach((to, from, next) => {
	/* 路由发生变化修改页面meta */
	/* 路由发生变化修改页面title */
	if(to.meta.title) {
		document.title = to.meta.title;
	}
	next()
});
/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	components: {
		App
	},
	template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js